<template>
    <div class="mt-3">
        <b-alert show variant="warning" class="my-custom-alert">
            <div class="text-center">
                <font-awesome-icon :icon="['fas', 'satellite-dish']" size="4x" class="text-secondary mb-1" />
            </div>
            <h4 class="alert-heading text-secondary">
                <slot name="heading">{{ heading }}</slot>
            </h4>
            <p class="text-secondary">
                <slot name="message">{{ message }}</slot>
            </p>
            <hr class="border-secondary">
            <p class="mb-0 text-secondary">
                Please try refreshing the page or check back in a few minutes.
            </p>
            <b-button size="md" variant="outline-secondary" class="mt-2" @click="reload">Retry</b-button>
        </b-alert>
    </div>
</template>

<script>
  import {
    BAlert,
    BButton
  } from 'bootstrap-vue'
export default {
    props: {
        heading: { type: String, default: 'Error loading' },
        message: { type: String, default: 'This could be due to a temporary issue with our server or your internet connection.' },
    },
    name: 'ErrorAlert',
    components: {
        BAlert,
        BButton
    },
    methods: {
        reload() {
            window.location.reload();
        }
    }
}
</script>

<style>
/* BootstrapVue overrides – non-scoped or global file */
.my-custom-alert {
    border: 1px solid transparent;
    border-radius: .25rem;
    margin-bottom: 1rem;
    padding: .75rem 1.25rem;
    position: relative;
}

.my-custom-alert .alert-heading {
    font-weight: 500;
    line-height: 1.2;
    margin-bottom: .5rem;
    font-size: 1.8rem;
    display: block;
    margin-block-start: 0.33em;
    margin-block-end: 0.33em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    font-weight: bold;
    unicode-bidi: isolate;
    box-shadow: none;
    padding: 0;
}
</style>